import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTE_MENU } from '../../../../constants';

const MenuLink: React.FC = () => {
  return (
    <Link to={ROUTE_MENU} className="btn btn-custom back-arrow-btn f-s14 px-0">
      Our Menu
    </Link>
  );
};

export default MenuLink;
